import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "space-y-1.5" }
const _hoisted_3 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_4 = { class: "min-w-0 truncate font-semibold text-catering-ink-900" }
const _hoisted_5 = { class: "text-catering-ink-400" }
const _hoisted_6 = { class: "shrink-0 tabular-nums text-catering-ink-700" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-catering-ink-500"
}
const _hoisted_8 = { class: "mt-1 flex flex-wrap gap-1" }
const _hoisted_9 = {
  key: 0,
  class: "rounded bg-catering-honey-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-honey-600"
}
const _hoisted_10 = {
  key: 0,
  class: "mt-2 space-y-0.5"
}


export default {
  __name: 'BotFulfillmentMethodList',
  props: { block: { type: Object, required: true } },
  setup(__props) {


function zoneLabel(m) {
  const parts = []
  if (m.has_delivery_area) parts.push('mapped delivery area')
  if ((m.eligible_states || []).length) parts.push(`states: ${m.eligible_states.join(', ')}`)
  if ((m.eligible_zip_codes || []).length) parts.push(`ZIPs: ${m.eligible_zip_codes.join(', ')}`)
  return parts.join(' · ')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Fulfillment methods", -1)),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.methods || [], (m, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-100 px-2.5 py-2"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(m.name) + " ", 1),
              _createElementVNode("span", _hoisted_5, "· " + _toDisplayString(m.type), 1)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(m.price), 1)
          ]),
          (zoneLabel(m))
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(zoneLabel(m)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.stores || [], (store, j) => {
              return (_openBlock(), _createElementBlock("span", {
                key: j,
                class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
              }, _toDisplayString(store), 1))
            }), 128)),
            (m.hide_times)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " times hidden "))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ]),
    ((__props.block.store_settings || []).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.store_settings, (s, i) => {
            return (_openBlock(), _createElementBlock("p", {
              key: i,
              class: "text-xs text-catering-ink-500"
            }, _toDisplayString(s.store_name) + ": order by " + _toDisplayString(s.fulfillment_method_order) + ", pickup visibility " + _toDisplayString(s.pickup_fulfillment_method_visibility), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}